import { makeRequest } from "./api";

export const CreateAdmin = async (email, password, roleId) => {
  return makeRequest("/api/admin/users/create", {
    method: "POST",
    data: { email, password, roleId },
  });
};

export const FetchAdmins = async (page, limit) => {
  return makeRequest(`/api/admin/users/fetch?page=${page}&limit=${limit}`);
};

export const DeleteAdmin = async (adminId) => {
  return makeRequest(`/api/admin/users/delete/${adminId}`, {
    method: "DELETE",
  });
};

export const UpdateAdmin = async (userId, email, password, roleId) => {
  return makeRequest("/api/admin/users/update", {
    method: "PUT",
    data: { userId, email, password, roleId },
  });
};
